module.exports = __webpack_public_path__ + "img/logo.41439bc7.png";